"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductService = exports.ProductParseError = exports.ProductNotFoundError = exports.GetProductRequestError = exports.GetProductsError = void 0;
const effect_1 = require("effect");
class GetProductsError {
    constructor(originalError) {
        this.originalError = originalError;
        this._tag = 'GetProductsError';
    }
}
exports.GetProductsError = GetProductsError;
class GetProductRequestError {
    constructor(originalError) {
        this.originalError = originalError;
        this._tag = 'GetProductRequestError';
    }
}
exports.GetProductRequestError = GetProductRequestError;
class ProductNotFoundError {
    constructor(productId) {
        this.productId = productId;
        this._tag = '@fixtuur/backpack/products/ProductNotFoundError';
    }
}
exports.ProductNotFoundError = ProductNotFoundError;
class ProductParseError {
    constructor(originalError, humanReadableError) {
        this.originalError = originalError;
        this.humanReadableError = humanReadableError;
        this._tag = '@fixtuur/backpack/products/ProductParseError';
    }
}
exports.ProductParseError = ProductParseError;
class ProductService extends effect_1.Context.Tag('@fixtuur/backpack/ProductService')() {
}
exports.ProductService = ProductService;
